// src/stores/initStore.js
import { writable } from "svelte/store";

export const isInitialized = writable(false);
export const authTokenStore = writable(null);
export const profileStore = writable(null);
export const clientKeyStore = writable("");
export const clientProfileStore = writable(null);
export const loadingStore = writable(false);
